import { render, staticRenderFns } from "./userGroupAjsSon.vue?vue&type=template&id=38dc6256&"
import script from "./userGroupAjsSon.vue?vue&type=script&lang=js&"
export * from "./userGroupAjsSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports